// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kO0e44UY4HU9YogFgjzB {
    display: flex;
    gap: 32px;
    margin-top: 16px;
    margin-bottom: 24px;
}

.TupP9dEEEXv7AZtlqslb {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Confirmation/ConfirmationWithPayment/ConfirmationWithPayment.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ","sourcesContent":[".confirmationDetailsWrapper {\n    display: flex;\n    gap: 32px;\n    margin-top: 16px;\n    margin-bottom: 24px;\n}\n\n.leftColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmationDetailsWrapper": `kO0e44UY4HU9YogFgjzB`,
	"leftColumn": `TupP9dEEEXv7AZtlqslb`
};
export default ___CSS_LOADER_EXPORT___;
